<template>
  <div id="Paper">
    <div class="paperContainer">
      <div class="font">

        <span
        >Wang, Bin,<b>Haigang Sui</b>, Guorui Ma, and Yuan Zhou. 
        "MCTracker: Satellite video multi-object tracking considering inter-frame motion correlation and multi-scale cascaded feature enhancement."
            <i>ISPRS Journal of Photogrammetry and Remote Sensing </i>214.(2024):82-103.
            https://doi.org/10.1016/j.isprsjprs.2024.06.006. [IF 2024 = 10.6]</span
        >
        <a href="https://doi.org/10.1016/j.isprsjprs.2024.06.006">[PDF]</a>
        <el-divider></el-divider>


        <span
        >Du, Zhuotong,<b>Haigang Sui</b>, Qiming Zhou,Mingting Zhou, Weiyue Shi,Jianxun Wang, and Junyi Liu. 
        "Vectorized building extraction from high-resolution remote sensing images using spatial cognitive graph convolution model."
            <i>ISPRS Journal of Photogrammetry and Remote Sensing </i> 213.(2024):53-71.
            https://doi.org/10.1016/j.isprsjprs.2024.05.015. [IF 2024 = 10.6]</span
        >
        <a href="https://doi.org/10.1016/j.isprsjprs.2024.05.015">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Zhao, Bofei,<b>Haigang Sui</b>, Junyi Liu,Weiyue Shi,Wentao Wang,Chuan Xu, and Jindi Wang. 
        "Flood inundation monitoring using multi-source satellite imagery: a knowledge transfer strategy for heterogeneous image change detection."
            <i>Remote Sensing of Environment </i> 314.(2024):114373-114373.
            https://www.sciencedirect.com/science/article/pii/S0034425724003997. [IF 2024 = 11.1]</span
        >
        <a href="https://www.sciencedirect.com/science/article/pii/S0034425724003997">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Li, Pengfei,Huini Wang,<b>Hongli Li</b>, Zixuan Ni,Hongxing Deng,Haigang Sui, and Guilin Xu. 
        "Refined Landslide Susceptibility Mapping Considering Land Use Changes and InSAR Deformation: A Case Study of Yulin City, Guangxi."
            <i>Remote Sensing </i> 16.16(2024):3016-3016.
            https://www.proquest.com/scholarly-journals/refined-landslide-susceptibility-mapping/docview/3098195883/se-2?accountid=15157. [IF 2024 = 4.2]</span
        >
        <a href="https://www.proquest.com/scholarly-journals/refined-landslide-susceptibility-mapping/docview/3098195883/se-2?accountid=15157">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Wang, Jianxun, Xin Chen,Tianqi Shi,Lieyun Hu,Weiyue Shi,Zhuotong Du, ...and <b>Haigang Sui</b>. 
        "Mapping national-scale photovoltaic power stations using a novel enhanced photovoltaic index and evaluating carbon reduction benefits."
            <i>Energy Conversion and Management</i> 318.(2024):118894-118894. 
            https://doi.org/10.1016/j.enconman.2024.118894. [IF 2024 = 9.9]</span
        >
        <a href="https://doi.org/10.1016/j.enconman.2024.118894">[PDF]</a>
        <el-divider></el-divider>



        <span
        >Wang, Bin, Guorui Ma, <b>Haigang Sui</b>, Yongxian Zhang, Haiming Zhang, and Yuan Zhou. 
        "Few-Shot Object Detection 
        in Remote Sensing Imagery via Fuse Context Dependencies and Global Features."
            <i>Remote Sensing   </i>15, no. 14 (2023): 3462.
            https://doi.org/10.3390/rs15143462. [IF 2024 = 4.2]</span
        >
        <a href="https://doi.org/10.3390/rs15143462">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Zhao, Bofei, <b>Haigang Sui</b>, and Junyi Liu. "Siam-DWENet: Flood 
            inundation detection for SAR imagery using a cross-task transfer 
            siamese network."
            <i>International Journal of Applied Earth Observation and Geoinformation
              </i>116 (2023).
            https://doi.org/10.1016/j.jag.2022.103132. [IF 2024 = 7.6]</span
        >
        <a href="https://doi.org/10.1016/j.jag.2022.103132">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Wang, Jianxun, Xin Chen, Weiyue Shi, Weicheng Jiang, Xiaopu Zhang, Li Hua, Junyi Liu, 
        and <b>Haigang Sui</b>. "Rooftop PV Segmenter: A 
        Size-Aware Network for Segmenting Rooftop Photovoltaic Systems from High-Resolution Imagery."
            <i>Remote Sensing
              </i>15, no. 21 (2023): 5232.
              https://doi.org/10.3390/rs15215232. [IF 2024 = 4.2]</span
        >
        <a href="https://doi.org/10.3390/rs15215232">[PDF]</a>
        <el-divider></el-divider>

        <span
        ><b>Sui, Haigang</b>, Jiajie Li, Junfeng Lei, Chang Liu, and Guohua Gou."A Fast and Robust Heterologous
         Image Matching Method for Visual Geo-Localization of Low-Altitude UAVs."
            <i>Remote Sensing
              </i>14, no. 22 (2022): 5879.
              https://doi.org/10.3390/rs14225879. [IF 2024 = 4.2]</span
        >
        <a href="https://doi.org/10.3390/rs14225879">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Wang, Jianxun, Xin Chen, Weicheng Jiang, Li Hua, Junyi Liu, and <b>Haigang Sui</b>. 
        "PVNet: A novel semantic 
        segmentation model for extracting high-quality photovoltaic panels in large-scale
         systems from high-resolution remote sensing imagery."
            <i>International Journal of Applied Earth Observation and Geoinformation
              </i>119 (2023).
              https://doi.org/10.1016/j.jag.2023.103309. [IF 2024 = 7.6]</span
        >
        <a href="https://doi.org/10.1016/j.jag.2023.103309">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Gou, Guohua, Xuanhao Wang, <b>Haigang Sui</b>, Sheng Wang, Hao Zhang, and Jiajie Li. 
        "OwlFusion: Depth-Only Onboard Real-Time 3D Reconstruction of Scalable Scenes for Fast-Moving MAV."
            <i>Drones</i>7, no. 6 (2023): 358.
            https://doi.org/10.3390/drones7060358. [IF 2024 = 4.4]</span
        >
        <a href="https://doi.org/10.3390/drones7060358">[PDF]</a>
        <el-divider></el-divider>

        <span
        ><b>Sui, Haigang</b>, Hao Zhang, Guohua Gou, Xuanhao Wang, Sheng Wang, Fei Li, and Junyi Liu. 
        "Multi-UAV Cooperative and Continuous Path Planning for High-Resolution 3D Scene Reconstruction."
            <i>Drones</i>7, no. 9 (2023): 544.
            https://doi.org/10.3390/drones7090544. [IF 2024 = 4.4]</span
        >
        <a href="https://doi.org/10.3390/drones7090544">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Shi, Weiyue, and <b>Haigang Sui</b>.
        "An effective superpixel-based graph convolutional network for small waterbody extraction from
         remotely sensed imagery."
            <i>International Journal of Applied Earth Observation and Geoinformation</i>109 (2022): 102777.
            https://doi.org/10.1016/j.jag.2022.102777. [IF 2024 = 7.6]</span
        >
        <a href="https://doi.org/10.1016/j.jag.2022.102777">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Zhou, Mingting, <b>Haigang Sui</b>, Shanxiong Chen, Junyi Liu, Weiyue Shi, and Xu Chen. 
        "Large-scale road extraction from high-resolution remote sensing images based on a
         weakly-supervised structural and orientational consistency constraint network."
            <i>ISPRS Journal of Photogrammetry and Remote Sensing</i>193 (2022): 234-251.
            https://doi.org/10.1016/j.isprsjprs.2022.09.005. [IF 2024 = 10.6]</span
        >
        <a href="https://doi.org/10.1016/j.isprsjprs.2022.09.005">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Chen, Xu, <b>Haigang Sui</b>, Jian Fang, Mingting Zhou, and Chen Wu. 
        "A novel AMS-DAT algorithm for moving vehicle detection in a satellite video."
            <i>IEEE Geoscience and Remote Sensing Letters</i>19 (2020): 1-5.
            https://doi.org/10.1109/LGRS.2020.3034677. [IF 2024 = 4.0]</span>
        <a href="https://doi.org/10.1109/LGRS.2020.3034677">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Gou, Guohua, <b>Haigang Sui</b>, Dajun Li, Zhe Peng, Bingxuan Guo, Wei Yang, 
        and Duo Huang. 
        "Limofilling: Local information guide hole-filling and sharp feature recovery 
        for manifold meshes."
            <i>Remote Sensing</i>14, no. 2 (2022): 289.
            https://doi.org/10.3390/rs14020289. [IF 2024 = 4.2]</span>
        <a href="https://doi.org/10.3390/rs14020289">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Wang, Sheng, Guohua Gou, <b>Haigang Sui</b>, Yufeng Zhou, Hao Zhang, and Jiajie Li.
        "CDSFusion: Dense Semantic SLAM for Indoor Environment Using CPU Computing."
            <i>Remote Sensing</i>14, no. 4 (2022): 979.
            https://doi.org/10.3390/rs14040979. [IF 2024 = 4.2]</span>
        <a href="https://doi.org/10.3390/rs14040979">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Liu, Chaoxian, <b>Haigang Sui</b>, Jianxun Wang, Zixuan Ni, and Liang Ge.
        "Real-time ground-level building damage detection based on lightweight and accurate
         YOLOv5 using terrestrial images."
            <i>Remote Sensing</i>14, no. 12 (2022): 2763.
            https://doi.org/10.3390/rs14122763. [IF 2024 = 4.2]</span>
        <a href="https://doi.org/10.3390/rs14122763">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Zhou, Mingting, <b>Haigang Sui</b>, Shanxiong Chen, Xu Chen, Wenqing Wang, Jianxun Wang, 
        and Junyi Liu. 
        "UGRoadUpd: An Unchanged-Guided Historical Road Database Updating Framework Based 
        on Bi-Temporal Remote Sensing Images."
            <i>IEEE Transactions on Intelligent Transportation Systems</i>23, no. 11 (2022): 21465-21477.
            https://doi.org/10.1109/TITS.2022.3181095. [IF 2024 = 7.9]</span>
        <a href="https://doi.org/10.1109/TITS.2022.3181095">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Liu, Chaoxian, <b>Haigang Sui</b>, and Lihong Huang. 
        "Identification of Damaged Building Regions From High- Resolution Images Using 
        Superpixel-Based Gradient and Autocorrelation Analysis."
            <i>IEEE Journal of Selected Topics in Applied Earth Observations and Remote Sensing</i>
            14 (2020): 1010-1024.
            https://doi.org/10.1109/JSTARS.2020.3034378. [IF 2023 = 4.7]</span>
        <a href="https://doi.org/10.1109/JSTARS.2020.3034378">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Du, Zhuotong, <b>Haigang Sui</b>, and Jindi Wang. 
        "A novel semantic recognition framework of urban functional zones supporting 
         land structure analytics based on open-source data."
            <i>Transactions in GIS</i>
            25, no. 3 (2021): 1460-1484.
            https://doi.org/10.1111/tgis.12736. [IF 2023 = 2.5]</span>
        <a href="https://doi.org/10.1111/tgis.12736">[PDF]</a>
        <el-divider></el-divider>

         <span
         >Zhou, Mingting, <b>Haigang Sui</b>, Shanxiong Chen, Jindi Wang, and
            Xu Chen. "Bt-Roadnet: A Boundary and Topologically-Aware Neural
            Network for Road Extraction from High-Resolution Remote Sensing
            Imagery." Isprs Journal of
            <i>Photogrammetry and Remote Sensing</i> 168 (Oct 2020): 288-306.
            https://doi.org/10.1016/j.isprsjprs.2020.08.019. [IF 2023 =
            10.6]</span
         >
        <a href="https://doi.org/10.1016/j.isprsjprs.2020.08.019">[PDF]</a>
        <router-link to="/dataset">[DataSet]</router-link>
        <el-divider></el-divider>

        <span
        >Chen, Xu, <b>Haigang Sui</b>, Jian Fang, Wenqing Feng, and Mingting
            Zhou. "Vehicle Re-Identification Using Distance-Based Global and
            Partial Multi-Regional Feature Learning."
            <i
            >IEEE Transactions on Intelligent Transportation Systems
              (2020).</i
            >
            https://doi.org/10.1109/TITS.2020.2968517. [IF 2023 = 7.9]</span
        >
        <a href="https://doi.org/10.1109/TITS.2020.2968517">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Feng, Wenqing, <b>Haigang Sui</b>, Li Hua, Chuan Xu, Guorui Ma, and
            Weiming Huang. "Building Extraction from Vhr Remote Sensing Imagery
            by Combining an Improved Deep Convolutional Encoder-Decoder
            Architecture and Historical Land Use Vector Map."<i
          >International Journal of Remote Sensing</i
          >
            41, no. 17 (Sep 1 2020): 6595-617.
            https://doi.org/10.1080/01431161.2020.1742944. [IF 2023 =
            3.3]</span
        >
        <a href="https://doi.org/10.1080/01431161.2020.1742944">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Liu, Chaoxian, <b>Haigang Sui</b>, and Lihong Huang.
            "Identification of Building Damage from Uav-Based Photogrammetric
            Point Clouds Using Supervoxel Segmentation and Latent Dirichlet
            Allocation Model." <i>Sensors</i> 20, no. 22 (Nov 2020).
            https://doi.org/10.3390/s20226499.[IF 2023 = 3.4]</span
        >
        <a href="https://doi.org/10.3390/s20226499">[PDF]</a>
        <el-divider></el-divider>

        <span
        >Chen, Xu, <b>Haigang Sui</b>, Jian Fang, Mingting Zhou, and Chen
            Wu. "Multi-Proxy Constraint Loss for Vehicle Re-Identification."
            <i>Sensors</i> 20, no. 18 (Sep 2020).
            https://doi.org/10.3390/s20185142.[IF 2023 = 3.4]</span
        >
        <a href="https://doi.org/10.3390/s20185142">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Xiao, Jinsheng, Jinglong Zhou, Junfeng Lei, Chuan Xu, and
            <b>Haigang Sui</b>. "Image Hazing Algorithm Based on Generative
            Adversarial Networks."<i>IEEE Access</i> 8 (2020): 15883-94.
            https://doi.org/10.1109/access.2019.2962784.[IF 2023 = 3.4]</span
        >
        <a href="https://doi.org/10.1109/access.2019.2962784">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Xiao, Jinsheng, Mengyao Shen, Junfeng Lei, Jinglong Zhou, Reinhard
            Klette, and <b>HaiGang Sui</b>. "Single Image Dehazing Based on
            Learning of Haze Layers." <i>Neurocomputing</i> 389 (May 14 2020):
            108-22. https://doi.org/10.1016/j.neucom.2020.01.007.[IF 2023 = 5.5]</span
        >
        <a href="https://doi.org/10.1016/j.neucom.2020.01.007">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Gong, Yiping, Zhifeng Xiao, Xiaowei Tan, <b>Haigang Sui</b>, Chuan
            Xu, Haiwang Duan, and Deren Li. "re Convolutional Neural
            Network for Object Detection in Vhr Remote Sensing Imagery."
            <i>IEEE Transactions on Geoscience and Remote Sensing</i> 58, no. 1
            (Jan 2020): 34-44. https://doi.org/10.1109/tgrs.2019.2930246.[IF 2023 = 7.5]</span
        >
        <a href="https://doi.org/10.1109/tgrs.2019.2930246">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Liu, Huajun, Shiran Tang, Dian Lei, Qing Zhu, <b>Haigang Sui</b>,
            Gaojian Zhang, and Chao Li. "Accurate Estimation of Feature Points
            Based on Individual Projective Plane in Video Sequence."
            <i>Visual Computer</i> 36, no. 10-12 (Oct 2020): 2091-103.
            https://doi.org/10.1007/s00371-020-01928-z.[IF 2023 = 3.0]</span
        >
        <a href="https://doi.org/10.1007/s00371-020-01928-z">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Feng, Wenqing, <b>Haigang Sui</b>, Weiming Huang, Chuan Xu, and
            Kaiqiang An. "Water Body Extraction from Very High-Resolution Remote
            Sensing Imagery Using Deep U-Net and a Superpixel-Based Conditional
            Random Field Model."
            <i>IEEE Geoscience and Remote Sensing Letters</i> 16, no. 4 (Apr
            2019): 618-622. https://doi.org/10.1109/lgrs.2018.2879492. [IF 2023 =
            4.0]</span
        >
        <a href="https://doi.org/10.1109/lgrs.2018.2879492">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Hua, Li, <b>Haigang Sui</b>, Wei Ding, Hongbo Fu, and Iop.
            "Automatic Geometric Correction of Complex Sea Condition Remote
            Sensing Image Based on Decision Tree Classification." Paper
            presented at the IOP Conference Series:
            <i>Earth and Environmental Science,</i> (2019) .</span
        >
        <a
            href="https://www.researchgate.net/publication/336155037_Automatic_Geometric_Correction_of_Complex_Sea_Condition_Remote_Sensing_Image_Based_on_Decision_Tree_Classification"
        >[PDF]</a
        >
        <el-divider></el-divider>
        <span
        >Hua, Li, Huidong Wang, <b>Haigang Sui</b>, Brian Wardlow, Michael
            J. Hayes, and Jianxun Wang. "Mapping the Spatial-Temporal Dynamics
            of Vegetation Response Lag to Drought in a Semi-Arid Region."
            <i>Remote Sensing</i> 11, no. 16 (Aug 2019).
            https://doi.org/10.3390/rs11161873.</span
        >
        <a href="https://doi.org/10.3390/rs11161873">[PDF]</a>
        <el-divider></el-divider>
        <span
        ><b>Sui, Haigang</b>, Kaiqiang An, Chuan Xu, Junyi Liu, and Wenqing
            Feng. "Flood Detection in Polsar Images Based on Level Set Method
            Considering Prior Geoinformation."
            <i>Geoscience and Remote Sensing Letters</i> 15, no. 5 (May 2018):
            699-703. https://doi.org/10.1109/lgrs.2018.2810122.</span
        >
        <a href="https://doi.org/10.1109/lgrs.2018.2810122">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Feng, Wenqing, <b>Haigang Sui</b>, Jihui Tu, Weiming Huang, and
            Kaimin Sun. "A Novel Change Detection Approach Based on Visual
            Saliency and Random Forest from Multi-Temporal High-Resolution
            Remote-Sensing Images."
            <i>International Journal of Remote Sensing</i> 39, no. 22 (2018):
            7998-8021. https://doi.org/10.1080/01431161.2018.1479794. [IF 2019 =
            2.976]</span
        >
        <a href="https://doi.org/10.1080/01431161.2018.1479794">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Feng, Wenqing, <b>Haigang Sui</b>, Jihui Tu, Weiming Huang, Chuan
            Xu, and Kaimin Sun. "A Novel Change Detection Approach for
            Multi-Temporal High-Resolution Remote Sensing Images Based on
            Rotation Forest and Coarse-to-Fine Uncertainty Analyses."
            <i>Remote Sensing</i> 10, no. 7 (Jul 2018).
            https://doi.org/10.3390/rs10071015.</span
        >
        <a href="https://doi.org/10.3390/rs10071015">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Ma, Guorui, <b>Haigang Sui</b>, Wenlong Wang, and Chun Wu. "A
            Kernel-Based Similarity Measuring for Change Detection in Remote
            Sensing Images."
            <i>Journal of the Indian Society of Remote Sensing</i> 45, no. 5
            (Oct 2017): 749-57. https://doi.org/10.1007/s12524-016-0642-x.</span
        >
        <a href="https://doi.org/10.1007/s12524-016-0642-x">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Tu, Jihui, <b>Haigang Sui</b>, Wenqing Feng, Kaimin Sun, Chuan Xu,
            and Qinhu Han. "Detecting Building Facade Damage from Oblique Aerial
            Images Using Local Symmetry Feature and the Gini Index."
            <i>Remote Sensing Letters</i> 8, no. 7 (2017): 676-85.
            https://doi.org/10.1080/2150704x.2017.1312027.</span
        >
        <a href="https://doi.org/10.1080/2150704x.2017.1312027">[PDF]</a>
        <el-divider></el-divider>
        <span
        >Dong, Hao, Xin Xu, <b>Haigang Sui</b>, Feng Xu, and Junyi Liu.
            "Copula-Based Joint Statistical Model for Polarimetric Features and
            Its Application in Polsar Image Classification."
            <i>IEEE Transactions on Geoscience and Remote Sensing</i> 55, no. 10
            (Oct 2017): 5777-89.
            https://doi.org/10.1109/tgrs.2017.2714169.</span
        >
        <a href="https://doi.org/10.1109/tgrs.2017.2714169">[PDF]</a>
        <el-divider></el-divider>

        <span>Tu, Jihui, <b>Haigang Sui</b>, Wenqing Feng, Kaimin Sun, and Li Hua. "Detection of Damaged Rooftop Areas from High-Resolution Aerial Images Based on Visual Bag-of-Words Model." <i>IEEE Geoscience and Remote Sensing Letters</i> 13, no. 12 (Dec 2016): 1817-21. https://doi.org/10.1109/lgrs.2016.2614298.</span>
        <a href="https://doi.org/10.1109/lgrs.2016.2614298">[PDF]</a>
        <el-divider></el-divider>
        <!-- 15 -->
        <span><b>Sui, Haigang</b>, Chuan Xu, Junyi Liu, and Feng Hua. "Automatic Optical-to-Sar Image Registration by Iterative Line Extraction and Voronoi Integrated Spectral Point Matching." <i>IEEE Transactions on Geoscience and Remote Sensing</i> 53, no. 11 (Nov 2015): 6058-72. https://doi.org/10.1109/tgrs.2015.2431498.</span>
        <a href="https://doi.org/10.1109/tgrs.2015.2431498">[PDF]</a>
        <el-divider></el-divider>
        <span>Liu, Junyi, <b>Haigang Sui</b>, Mingming Tao, Kaimin Sun, and Xin Mei. "Road Extraction from Sar Imagery Based on an Improved Particle Filtering and Snake Model." <i>International Journal of Remote Sensing</i> 34, no. 22 (Nov 20 2013): 8199-214. https://doi.org/10.1080/01431161.2013.835082.</span>
        <a href="https://doi.org/10.1080/01431161.2013.835082">[PDF]</a>
        <el-divider></el-divider>
        <!-- 12 -->
        <span><b>Sui, Haigang</b>, Feifei Peng, Chuan Xu, Kaimin Sun, and Jianya Gong. "Gpu-Accelerated Mrf Segmentation Algorithm for Sar Images." <i>Computers & Geosciences</i> 43 (Jun 2012): 159-66. https://doi.org/10.1016/j.cageo.2011.10.001.</span>
        <a href="https://doi.org/10.1016/j.cageo.2011.10.001">[PDF]</a>
        <el-divider></el-divider>
        <span><b>Sui, Haigang</b>, Chuan Xu, Junyi Liu, Kaimin Sun, and Chengfeng Wen. "A Novel Multi-Scale Level Set Method for Sar Image Segmentation Based on a Statistical Model." <i>International Journal of Remote Sensing</i> 33, no. 17 (2012): 5600-14. https://doi.org/10.1080/01431161.2012.666814.</span>
        <a href="https://doi.org/10.1080/01431161.2012.666814">[PDF]</a>
        <el-divider></el-divider>
        <!-- 2010 -->
        <span>Sun, KaiMin, <b>Haigang Sui</b>, DeRen Li, and Chuan Xu. "A New Relative Radiometric Consistency Processing Method for Change Detection Based on Wavelet Transform and a Low-Pass Filter." <i>Science China-Technological Sciences</i> 53 (May 2010): 7-14. https://doi.org/10.1007/s11431-010-3197-z.</span>
        <a href="https://doi.org/10.1007/s11431-010-3197-z">[PDF]</a>
        <el-divider></el-divider>
        <span>Gong, JianYa, <b>Haigang Sui</b>, KaiMin Sun, GuoRui Ma, and JunYi Liu. "Object-Level Change Detection Based on Full-Scale Image Segmentation and Its Application to Wenchuan Earthquake." <i>Science in China Series E-Technological Sciences</i> 51 (Dec 2008): 110-22. https://doi.org/10.1007/s11431-008-6017-y.</span>
        <a href="https://doi.org/10.1007/s11431-008-6017-y">[PDF]</a>
        <el-divider></el-divider>
      </div>
    </div>
<!--    <el-tabs v-model="activeName" @tab-click="handleClick">-->
<!--      <el-tab-pane label="2020年 - 2021年" name="first">-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="2017年 - 2019年" name="second">-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="2011年 - 2016年" name="third">-->
<!--      </el-tab-pane>-->
<!--    </el-tabs>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang='less' scoped>
#Paper {
    margin-top: 8px;
  .paperContainer{
    height: 600px;
    overflow-y: scroll;
  }
  .paperContainer::-webkit-scrollbar {
    width: 6px;
  }
  .paperContainer::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(208, 208, 208, 0.4);
  }
  .font {
    //font-family: "Times New Roman", Times, serif;
    font-size: 14px;
    color: #454545;
    line-height: 24px;
  }
}
</style>
